'use client';

import { useMutation } from '@tanstack/react-query';
import { gitClient } from '@terra/shared-rest-clients-git';
import { getAuthHeaders } from '../../utils/authHeaders';
import { getCurrentGatewayUrl } from '../../utils/environmentDetection';

const gitClientOptions = () => ({
  baseUrl: `${getCurrentGatewayUrl()}/git`,
});

export function useTriggerDeepSecurityScan({
  applicationId,
}: {
  applicationId?: string;
}) {
  return useMutation({
    mutationFn: async () => {
      if (!applicationId) {
        throw new Error('Application ID is required');
      }

      const authHeaders = await getAuthHeaders();
      const response = await gitClient.triggerDeepSecurityTestCaseScan({
        params: { applicationId },
        body: {},
        overrideClientOptions: gitClientOptions(),
        extraHeaders: {
          ...authHeaders,
        },
      });

      if (response.status !== 202) {
        throw new Error(
          response.status === 500
            ? response.body.message
            : 'Failed to trigger deep security scan',
        );
      }

      return response.body;
    },
  });
}
